import React from 'react';
import useLanguage from '../../hooks/useLanguage';

/**
 * Language Switcher Component
 * Toggles between Korean and English
 * Uses Language Context for global state management
 */
const LanguageSwitcher = () => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center space-x-2 px-4 py-2 text-sm font-medium text-gray-700 hover:text-primary transition-colors duration-200"
      aria-label="Switch Language"
    >
      <span className={`${language === 'ko' ? 'font-bold text-primary' : 'text-gray-500'}`}>
        한국어
      </span>
      <span className="text-gray-400">|</span>
      <span className={`${language === 'en' ? 'font-bold text-primary' : 'text-gray-500'}`}>
        English
      </span>
    </button>
  );
};

export default LanguageSwitcher;
